const { feWp } = window;
const { doAction, applyFilters } = feWp.hooks;

const sliderDOMContentLoaded = () => {
  const breakpoints = applyFilters('b3rg_slider_breakpoints', {});

  const getCurrentBreakpoint = (resolution) => {
    for (const device in breakpoints) {
      if (resolution <= breakpoints[device]) {
        return device;
      }
    }
    return 'desktop'; // Default to desktop if no match is found
  };

  // Allows filtering whether to use window.innerWidth or screen.width
  const useWindowInnerWidth = applyFilters(
    'b3rg_use_window_inner_width',
    false,
  );
  const getWidth = () =>
    // eslint-disable-next-line no-undef
    useWindowInnerWidth ? window.innerWidth : screen.width;

  // Gets the initial breakpoint based on the filtered width method
  let currentBreakpointVal = getCurrentBreakpoint(getWidth());

  // On page load
  doAction('b3rg_breakpoint_changed', currentBreakpointVal);

  // On page resize
  const handleOnResize = (entries) => {
    for (const entry of entries) {
      const { contentRect } = entry;
      const windowWidth = contentRect.width;
      const currentBreakpoint = getCurrentBreakpoint(windowWidth);

      if (currentBreakpointVal !== currentBreakpoint) {
        currentBreakpointVal = currentBreakpoint;
        doAction('b3rg_breakpoint_changed', currentBreakpoint);
      }
    }
  };

  // eslint-disable-next-line no-undef
  const resizeObserver = new ResizeObserver(handleOnResize);
  resizeObserver.observe(document.body);
};

document.addEventListener('DOMContentLoaded', sliderDOMContentLoaded);
